export class RoleInclusaoDTO {

  public descricao?: string;
  public tipoAcesso!: 'EXTERNO' | 'INTERNO';
  public menuIds?: (number | string)[];
  public nivelHierarquia!: number;
  originadorRoleIds?: (string | number)[];
  idRoleOrigem?: string | number | null;
  public status?: boolean | null;
  private nomeRoleOrigem?: string;
  
}